import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { addPositiveToast, addNegativeToast } from 'modules/toastContainer';

type ToastCallback = (message: string | React.ReactNode) => void;

export const useToastNotificationCallback = () => {
  const dispatch = useDispatch();

  const positive: ToastCallback = useCallback(
    (message) => dispatch(addPositiveToast(message)),
    [dispatch],
  );
  const negative: ToastCallback = useCallback(
    (message) => dispatch(addNegativeToast(message)),
    [dispatch],
  );

  return { positive, negative };
};
